<template>
  <div :class="`items dorpdown_theme  `">
    <template v-for="(section, index) in newItem[currentLang].sections">
      <div :key="`${index}_sections_menu`">
        <div
          :class="`app-card-list-item full_category `"
          @click="
            selected = index;
            funcCollapsedSection(index);
          "
        >
          <div class="inner">
            <div class="left">
              <span :class="`title `" v-text="section.title">{{
                section.title
              }}</span>
            </div>
          </div>
        </div>
        <div :class="`menu_items1  `" v-if="vIfcollapsedSection(index)">
          <template
            v-for="(subSection, indexSubCategorie) in section.sub_sections"
          >
            <div
              :key="`${indexSubCategorie}_sub_sections_menu`"
              @click="sub_selected = indexSubCategorie"
              v-if="showSub(subSection)"
            >
              <div :class="`app-card-list-item `">
                <span
                  :class="`round-button ${smaler ? 'smaller_image' : ''}`"
                  style="width: 54px; height: 54px; min-width: 54px; min-height: 54px; padding: 12px;"
                >
                  <img
                    src="https://space.monresto.menu/resto/img/menu-default.png"
                    alt="Menu Brunch"
                    class=""
                  />
                  <span class="counter"></span>
                </span>
                <div class="inner">
                  <div class="left">
                    <span
                      :class="`title  `"
                      v-text="
                        subSection.title == 'null-sub-sections'
                          ? ''
                          : subSection.title
                      "
                      >{{ subSection.title }}</span
                    >
                  </div>
                  <div @click="collapsedArray(indexSubCategorie, selected)">
                    <img
                      src="https://space.monresto.menu/icons/caret-down.png"
                      class="down_dropdown"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div
                class="menu_items"
                v-if="
                  showSub(subSection) &&
                    vIfcollapsed(indexSubCategorie, selected)
                "
              >
                <div
                  v-for="(item, indiceItem) in subSection.items"
                  :key="`${indexSubCategorie}_${indiceItem}_mwnu_items`"
                  class="product mt-2 d-flex justify-content-between align-items-center my_item_ "
                  @click="
                    (e) => {
                      addToCart(item, e);
                    }
                  "
                  style="color:#1BAAAE"
                >
                  <div class="content">
                    <div class="d-flex flex-column">
                      <span :class="`title  `" v-text="item.title"
                        >{{ item.title }}
                      </span>
                      <span class="option"></span>
                      <span
                        :class="`mt-1 description-dropdown `"
                        v-text="item.observation"
                        >{{ item.observation }}</span
                      >
                      <span class="tags" style="color:#1BAAAE"> </span>
                    </div>
                    <span class="badge"></span>
                    <div style="display: flex;">
                      <span
                        class="price-dropdown"
                        style="color:#1BAAAE"
                        v-text="item.price"
                        >{{ item.price }}</span
                      >
                      {{ currentCurrency.symbol }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: [
    "smaler",
    "newItem",
    "newSection",
    "listSections",
    "changeSectionTitle",
    "changeSectionSubTitle",
    "setCurrentTab",
    "currentTab",
    "addItem",
    "newSubSection",
    "handleChangeShowSub",
    "disponibleItem",
    "showItem",
    "changeItemObservation",
    "changeItemPrice",
    "changeItemTitle",
    "editCategorie",
    "deleteSection",
    "editSubCategorie",
    "deleteSubSection",
    "editItem",
    "deleteItem",
    "currentCurrency",
    "currentLang",
    "addToCart",
  ],
  data() {
    return {
      selected: 0,
      sub_selected: 0,
      collapsedSubSection: [],
      collapsedArrayVar: [],
      collapsedSection: [],
    };
  },
  watch: {
    selected(newval) {
      // if(newVal!=this.currentTab){
      this.setCurrentTab(newval);
      // }
    },
    currentTab(newVal) {
      if (newVal != this.selected) {
        this.selected = newVal;
      }
    },
  },
  methods: {
    vIfcollapsed(indexSubCategorie, indexSection) {
      let searchedIndice = indexSection + "_" + indexSubCategorie;
      let item = this.collapsedArrayVar.find((item) => item == searchedIndice);
      if (item) {
        return true;
      } else {
        return false;
      }
    },
    vIfcollapsedSection(indexSection) {
      indexSection = `cat${indexSection}`;
      let item = this.collapsedSection.find((item) => item == indexSection);
      if (item) {
        return true;
      } else {
        return false;
      }
    },

    funcCollapsedSection(indexSection) {
      indexSection = `cat${indexSection}`;

      if (this.collapsedSection.includes(indexSection)) {
        this.collapsedSection.splice(
          this.collapsedSection.indexOf(indexSection),
          1
        );
      } else {
        this.collapsedSection.push(indexSection);
      }
    },
    collapsedArray(indexSubCategorie, indexSection) {
      let searchedIndice = indexSection + "_" + indexSubCategorie;

      if (this.collapsedArrayVar.includes(searchedIndice)) {
        this.collapsedArrayVar.splice(
          this.collapsedArrayVar.indexOf(searchedIndice),
          1
        );
      } else {
        this.collapsedArrayVar.push(searchedIndice);
      }
    },
    toggleCollapsed(index) {
      if (this.collapsedSubSection.includes(index)) {
        this.collapsedSubSection.splice(
          this.collapsedSubSection.indexOf(index)
        );
      } else {
        this.collapsedSubSection.push(index);
      }
    },
    deleteCategorie() {
      let old_selected = this.selected;
      if (this.selected != 0) {
        this.selected = this.selected - 1;
      }
      this.deleteSection(old_selected);
    },
    showSub(subSection) {
      console.log(this.listSections);
      if (this.listSections[this.selected].show_subCategories == undefined) {
        return true;
      }
      if (
        this.newItem[0].sections[this.selected].show_subCategories &&
        !subSection.defaultNonSub
      ) {
        return true;
      } else if (
        !this.newItem[0].sections[this.selected].show_subCategories &&
        subSection.defaultNonSub
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style>
#ddown12_dropdown_theme,
#ddown13_dropdown_theme {
  padding: 0 !important;
  margin-right: 1em;
}
.dorpdown_theme .new_sub_dropdown_theme {
  background-color: #fff;
  color: black;
  border-radius: 50px;
  /* padding: 3px 6px; */
}
.new_sub_dropdown_theme .btn-outline-secondary {
  background-color: initial !important;
  color: initial !important;
  border: none !important;
  border-color: initial !important;
  padding: 0px !important;
}
.sub_category_options {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.price {
  margin-right: 6px;
}
.dorpdown_theme.items {
  background: #fff;
  min-height: unset;
  width: 100%;
  padding: 24px;
}
.dorpdown_theme.items.smaller {
  background: #fff;
  min-height: unset;
  width: 100%;
  padding: 12px;
}

.app-card-list-item {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  background: #fff;
  box-shadow: 0 4px 15px rgba(35, 41, 54, 0.04);
  border-radius: 80px;
  border: none;
  color: #333;
  cursor: pointer;
  padding: 0;
  text-decoration: none;
  transition: all 0.15s linear;
  margin-top: 24px;
}

.round-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(0deg, #fff, #fff),
    linear-gradient(146.54deg, #f5788c -2.39%, #fba16a 85.82%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border: none;
  padding: 18px;
  box-sizing: border-box;
  cursor: pointer;
  text-decoration: none;
  color: #373a42;
  transition: all 0.15s linear;
  width: 54px;
  height: 54px;
  min-width: 54px;
  min-height: 54px;
  padding: 12px;
  position: relative;
}
.round-button img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.app-card-list-item .inner {
  display: flex;
  flex: 1 1 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
.app-card-list-item .left {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.app-card-list-item .title {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: start;
}
.app-card-list-item .right {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.app-card-list-item .caption {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  text-align: end;
  padding-right: 20px;
  color: #616368;
}
.app-card-list-item .arrow {
  height: 13px;
}
/* .container {
  padding-bottom: 200px;
} */
.spacer {
  height: 100px;
}
.flex-column {
  flex-direction: column;
  width: 100%;
}
.product {
  padding: 12px 0px;
  position: relative;
  flex-direction: column;
}

.product .content {
  display: flex;
  flex-direction: row;
  width: 90%;
  align-items: center;
}
.product .title {
  /* font-family: Work Sans; */
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  margin-bottom: 0;
  color: #333;
  text-align: left;
}
.option {
  /* font-family: Work Sans; */
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  text-transform: uppercase;
  margin-top: 6px;
  margin-bottom: -3px;
}

span.description {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 4px;
  max-width: 95%;
  color: #333;
}
.tags {
  /* font-family: Work Sans; */
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  width: 80%;
  opacity: 0.5;
}
.menu_items {
  /* display: none; */
}

.actions {
  position: relative;
  display: flex;
  width: 100%;
  min-width: 100%;
  height: 100%;
  background-color: #41403e;
  background-color: #fdc877;
  background-color: #f1a129;
  justify-content: space-around;
  align-items: center;
  margin-top: 6px;
  /* display: none; */
}
.plus {
  /* flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  height: 100%;
  margin: 0px !important;
  color: #fff; */
}

.quantity {
  flex: 2;
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 25px;
  border-left: 1px solid var(--muted-light);
  border-right: 1px solid var(--muted-light);
  height: 100%;
  color: #fff;
}
.minus {
  /* flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: #fff; */
  /* font-size: 25px;
  height: 100%;
  margin: 0px !important;
  color: #fff;  */
}

.visitor-contact-request {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 10px;
  align-items: center;
  justify-content: center;
  background-color: #82a3a7;
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  transition: all 0.015s linear;
  transform: translateY(100%);
  opacity: 0;
  max-width: 760px;
  margin: auto;
}
.menu_items1 {
  padding: 12px 24px;
}
.full_category {
  height: 54px;
  background: #28b3b7;
  color: white;
}
.full_category1 {
  height: 54px;
  background: #fff;
  color: black;
  border: 1px solid black;
  justify-content: center;
  align-items: center;
  text-align: center;
  display: flex;
}
.full_category1:hover {
  background: black;
  color: #fff;
}
.full_category1 .inner {
  justify-content: center;
  align-items: center;
}
.app-card-list-item {
  cursor: pointer;
}
@media only screen and (max-width: 800px) {
  .app-card-list-item .title,
  .product .title,
  span.description {
    font-size: 12px;
  }
  .menu_items1 {
    padding: 12px 12px;
  }
}

.description.smaller {
  font-size: 8px;
}
.title.smaller {
  font-size: 12px;
}
.full_category.smaller {
  height: 30px;
}
.smaller_image {
  width: 30px !important;
  height: 30px !important;
  min-width: 30px !important;
  min-height: 30px !important;
  padding: 2px !important;
}
.menu_items1.smaller {
  padding: 1px 14px;
}
.app-card-list-item.smaller {
  margin-top: 12px;
}
#ddown1_dropdown_theme {
  /* padding: 0; */
  padding: 5px !important;
  /* margin-right: 1em; */
}
.description-dropdown {
  text-align: left;
}
.price-dropdown {
  font-weight: 700;
}
.down_dropdown {
  width: 20px;
  height: auto;
  filter: brightness(0.8);
}
</style>
